import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import TextChart from "../../../Charts/TextChart";
import { formatNumber } from "../../../../assets/shared/formatNumber";

const TextoUltimaCompra = (props) => {
  const {
    clientSelected,
    fecha,
    idComproba,
    nombre,
    referencia,
    total,
    loading,
  } = props;

  const indSinInfo = idComproba === undefined || idComproba === null;
  const validateDate = moment(fecha).format("DD/MM/YYYY");

  return (
    <TextChart
      title={`Última compra`}
      bigAmount={
        indSinInfo || validateDate._isValid
          ? "Sin info"
          : moment(fecha).format("DD/MM/YYYY")
      }
      smallTextTooltip={
        !indSinInfo && (
          <div>
            Nombre: {nombre}
            <br />
            Numero: {referencia}
            <br />
            Importe:
            {` ${sessionStorage.getItem("monedaSigno")} ${formatNumber(total)}`}
          </div>
        )
      }
      noClient={!clientSelected}
      smallText={
        !indSinInfo
          ? `Comprobante: ${idComproba} ${referencia}`
          : "Comprobante: -"
      }
      loading={loading}
      imgSinDatos={indSinInfo}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    clientSelected: state.clientes.clienteById.clientSelected,
    fecha: state.clientes.ultimaCompra.fecha,
    idComproba: state.clientes.ultimaCompra.idComproba,
    nombre: state.clientes.ultimaCompra.nombre,
    referencia: state.clientes.ultimaCompra.referencia,
    total: state.clientes.ultimaCompra.total,
    loading: state.clientes.ultimaCompra.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoUltimaCompra);
